import React from 'react';
import { Card, Typography, Divider, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const TermsOfService: React.FC = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={{
            background: 'linear-gradient(135deg, #fef4f4 0%, #fff9f9 100%)',
            minHeight: '100vh',
            padding: isMobile ? '20px' : '40px'
        }}>
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate('/')}
                    style={{ marginBottom: '24px' }}
                >
                    Torna alla Home
                </Button>

                <Card style={{
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }}>
                    <Title level={1} style={{ textAlign: 'center', marginBottom: '8px' }}>
                        Termini di Servizio
                    </Title>
                    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: '32px' }}>
                        Ultimo aggiornamento: 11 Novembre 2024
                    </Text>

                    <Divider />

                    <Title level={3}>1. Accettazione dei Termini</Title>
                    <Paragraph>
                        Accedendo e utilizzando babbonatalesegreto.icu ("Servizio"), accetti di essere vincolato dai
                        presenti Termini di Servizio. Se non accetti questi termini, ti preghiamo di non utilizzare
                        il Servizio.
                    </Paragraph>

                    <Title level={3}>2. Descrizione del Servizio</Title>
                    <Paragraph>
                        babbonatalesegreto.icu è una piattaforma web che consente agli utenti di:
                    </Paragraph>
                    <ul>
                        <li>Creare e gestire sorteggi per lo scambio di regali "Secret Santa"</li>
                        <li>Aggiungere partecipanti tramite indirizzo email</li>
                        <li>Definire esclusioni personalizzate tra partecipanti</li>
                        <li>Generare automaticamente abbinamenti casuali</li>
                        <li>Inviare notifiche email ai partecipanti con i risultati del sorteggio</li>
                    </ul>

                    <Title level={3}>3. Registrazione e Account</Title>
                    <Paragraph>
                        Per utilizzare il Servizio è necessario:
                    </Paragraph>
                    <ul>
                        <li>Essere maggiorenne o avere il consenso di un genitore/tutore</li>
                        <li>Fornire informazioni accurate e veritiere durante la registrazione</li>
                        <li>Mantenere la sicurezza del proprio account</li>
                        <li>Notificare immediatamente eventuali accessi non autorizzati</li>
                    </ul>
                    <Paragraph>
                        Sei responsabile di tutte le attività che avvengono tramite il tuo account.
                    </Paragraph>

                    <Title level={3}>4. Utilizzo Accettabile</Title>
                    <Paragraph>
                        Ti impegni a NON:
                    </Paragraph>
                    <ul>
                        <li>Utilizzare il Servizio per scopi illegali o non autorizzati</li>
                        <li>Inserire indirizzi email senza il consenso dei destinatari</li>
                        <li>Inviare spam, contenuti offensivi o inappropriati</li>
                        <li>Tentare di violare la sicurezza del sistema</li>
                        <li>Utilizzare bot, scraper o altri metodi automatizzati senza autorizzazione</li>
                        <li>Interferire con il funzionamento del Servizio</li>
                        <li>Impersonare altre persone o entità</li>
                    </ul>

                    <Title level={3}>5. Proprietà Intellettuale</Title>
                    <Paragraph>
                        Il Servizio, inclusi ma non limitati a design, grafica, testo, codice sorgente e funzionalità,
                        è di proprietà di babbonatalesegreto.icu ed è protetto dalle leggi sul copyright e sulla
                        proprietà intellettuale.
                    </Paragraph>
                    <Paragraph>
                        Ti è concessa una licenza limitata, non esclusiva e non trasferibile per utilizzare il Servizio
                        per scopi personali e non commerciali.
                    </Paragraph>

                    <Title level={3}>6. Contenuti dell'Utente</Title>
                    <Paragraph>
                        Sei responsabile dei contenuti che inserisci nel Servizio (nomi, email, titoli sorteggi).
                        Conserviamo il diritto di rimuovere contenuti che violano questi Termini o che riteniamo
                        inappropriati.
                    </Paragraph>
                    <Paragraph>
                        Garantisci di avere il diritto di inserire gli indirizzi email dei partecipanti e di aver
                        ottenuto il loro consenso all'invio delle notifiche.
                    </Paragraph>

                    <Title level={3}>7. Privacy e Protezione dei Dati</Title>
                    <Paragraph>
                        Il trattamento dei tuoi dati personali è regolato dalla nostra
                        <a href="/privacy" style={{ marginLeft: '4px', marginRight: '4px' }}>Privacy Policy</a>
                        in conformità al GDPR. Utilizzando il Servizio, accetti il trattamento dei dati come descritto
                        nella Privacy Policy.
                    </Paragraph>

                    <Title level={3}>8. Disponibilità del Servizio</Title>
                    <Paragraph>
                        Il Servizio è fornito "così com'è" e "come disponibile". Non garantiamo che:
                    </Paragraph>
                    <ul>
                        <li>Il Servizio sarà sempre disponibile, ininterrotto o privo di errori</li>
                        <li>I difetti saranno corretti</li>
                        <li>Il Servizio sarà sicuro o esente da virus</li>
                    </ul>
                    <Paragraph>
                        Ci riserviamo il diritto di modificare, sospendere o interrompere il Servizio in qualsiasi
                        momento senza preavviso.
                    </Paragraph>

                    <Title level={3}>9. Limitazione di Responsabilità</Title>
                    <Paragraph>
                        Nella misura massima consentita dalla legge, babbonatalesegreto.icu non sarà responsabile per:
                    </Paragraph>
                    <ul>
                        <li>Danni diretti, indiretti, incidentali, speciali o consequenziali</li>
                        <li>Perdita di dati, profitti o opportunità commerciali</li>
                        <li>Uso improprio del Servizio da parte di terzi</li>
                        <li>Problemi tecnici o interruzioni del servizio</li>
                    </ul>

                    <Title level={3}>10. Indennizzo</Title>
                    <Paragraph>
                        Accetti di indennizzare e tenere indenne babbonatalesegreto.icu da qualsiasi reclamo, perdita,
                        responsabilità, spese o costi (incluse le spese legali) derivanti da:
                    </Paragraph>
                    <ul>
                        <li>Violazione di questi Termini</li>
                        <li>Violazione di diritti di terze parti</li>
                        <li>Uso improprio del Servizio</li>
                    </ul>

                    <Title level={3}>11. Risoluzione</Title>
                    <Paragraph>
                        Possiamo sospendere o terminare il tuo accesso al Servizio immediatamente, senza preavviso,
                        in caso di:
                    </Paragraph>
                    <ul>
                        <li>Violazione di questi Termini</li>
                        <li>Uso fraudolento o illegale del Servizio</li>
                        <li>Richiesta da parte di autorità competenti</li>
                    </ul>
                    <Paragraph>
                        Puoi cessare di utilizzare il Servizio in qualsiasi momento eliminando il tuo account.
                    </Paragraph>

                    <Title level={3}>12. Modifiche ai Termini</Title>
                    <Paragraph>
                        Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento. Le modifiche
                        sostanziali saranno comunicate tramite email o notifica sul sito. L'uso continuato del Servizio
                        dopo le modifiche costituisce accettazione dei nuovi Termini.
                    </Paragraph>

                    <Title level={3}>13. Legge Applicabile e Foro Competente</Title>
                    <Paragraph>
                        Questi Termini sono regolati dalla legge italiana. Qualsiasi controversia sarà di competenza
                        esclusiva del Foro di Savona, Italia.
                    </Paragraph>

                    <Title level={3}>14. Clausola di Salvaguardia</Title>
                    <Paragraph>
                        Se una disposizione di questi Termini è ritenuta non valida o non applicabile, le restanti
                        disposizioni rimarranno in vigore.
                    </Paragraph>

                    <Title level={3}>15. Contatti</Title>
                    <Paragraph>
                        Per domande o chiarimenti sui Termini di Servizio, contattaci all'indirizzo email:
                        <a href="mailto:info@marchiosoft.com" style={{ marginLeft: '4px' }}>info@marchiosoft.com</a>
                    </Paragraph>

                    <Divider />

                    <div style={{ textAlign: 'center', marginTop: '32px' }}>
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => navigate('/')}
                        >
                            Torna alla Home
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default TermsOfService;
